import utility from "core/Utils";
import {
  NavLink,
  Outlet,
  useLocation,
  useOutletContext,
} from "react-router-dom";
const { default: Header } = require("../../common/Header");

const Clients = () => {
  const location = useLocation();
  const { token, menuPermissions } = useOutletContext();

  const menus = utility.buildSubMenuFromLocation(location, menuPermissions);
  const { name, client_name } = token;

  return (
    <div id="clients" className="page">
      <Header user={name} client_name={client_name} title="Clients">
        {menus.map(menu => (
          <NavLink
            className={({ isActive }) => (isActive ? "active" : undefined)}
            key={menu.item}
            to={utility.getLastPartOfPath(menu.pathname)}
          >
            {menu.item}
          </NavLink>
        ))}
      </Header>
      <Outlet context={token} />
    </div>
  );
};

export default Clients;
